var map = {
	"./bug.svg": 17,
	"./dark.svg": 18,
	"./dragon.svg": 19,
	"./electric.svg": 20,
	"./fairy.svg": 21,
	"./fighting.svg": 22,
	"./fire.svg": 23,
	"./flying.svg": 24,
	"./ghost.svg": 25,
	"./grass.svg": 26,
	"./ground.svg": 27,
	"./ice.svg": 28,
	"./normal.svg": 29,
	"./poison.svg": 30,
	"./psychic.svg": 31,
	"./rock.svg": 32,
	"./steel.svg": 33,
	"./water.svg": 34
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;